import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ConfirmModalSimple,
  ConfirmModalSimpleProps,
} from '../../../../components/ConfirmModalSimple';

type Props = Omit<ConfirmModalSimpleProps, 'message'> & {
  message?: string;
};

export const DeleteConfirmation = ({ message, ...restProps }: Props) => {
  const { t } = useTranslation();

  return (
    <ConfirmModalSimple
      {...restProps}
      message={message ?? t('form.general.defaultConfirmationText')}
    />
  );
};
